import { render, staticRenderFns } from "./SchedulesBoard.vue?vue&type=template&id=d5b3db1e&scoped=true"
import script from "./SchedulesBoard.vue?vue&type=script&lang=js"
export * from "./SchedulesBoard.vue?vue&type=script&lang=js"
import style0 from "./SchedulesBoard.vue?vue&type=style&index=0&id=d5b3db1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b3db1e",
  null
  
)

export default component.exports